import axios from "axios"

export default {
	getProfileAssignment(paID) {
		return axios.get(`/v1/assignments/profile/${paID}`)
	},
	saveProfileAssignment(pa) {
		return axios.post(`/v1/assignments/profile`, pa)
	},

	deleteProfileAssignment(paID) {
		return axios.delete(`/v1/assignments/profile/${paID}`)
	},

	getPitchAssignment(paID) {
		return axios.get(`/v1/assignments/pitch/${paID}`)
	},
	savePitchAssignment(pa) {
		return axios.post(`/v1/assignments/pitch`, pa)
	},

	deletePitchAssignment(paID) {
		return axios.delete(`/v1/assignments/pitch/${paID}`)
	},
	
	getPrototypeAssignment(paID) {
		return axios.get(`/v1/assignments/prototype/${paID}`)
	},
	savePrototypeAssignment(pa) {
		return axios.post(`/v1/assignments/prototype`, pa)
	},
	deletePrototypeAssignment(paID) {
		return axios.delete(`/v1/assignments/prototype/${paID}`)
	},

	getTVRAssignment(tvrID) {
		return axios.get(`/v1/assignments/tvr/${tvrID}`)
	},
	saveTVRAssignment(tvr) {
		return axios.post(`/v1/assignments/tvr`, tvr)
	},

	deleteTVRAssignment(tvrID) {
		return axios.delete(`/v1/assignments/tvr/${tvrID}`)
	},

	getCanvasAssignment(caID) {
		return axios.get(`/v1/assignments/canvas/${caID}`)
	},
	saveCanvasAssignment(ca) {
		return axios.post(`/v1/assignments/canvas`, ca)
	},

	deleteCanvasAssignment(caID) {
		return axios.delete(`/v1/assignments/canvas/${caID}`)
	},
}